import { intersect, partial, string, struct } from 'io-ts/Decoder';

import { Id as FileId } from '../../../file/Id';
import { ParentId } from '../../../file/ParentId';

export const Params = intersect(
	struct({
		parentId: ParentId,
		fileId: FileId,
	})
)(
	partial({
		pageNumber: string,
	})
);
